import VideoConversation from "../VideoConversation";

class ScorecardModel{

    fields = [];
    maxFails = 1;

    constructor(data) {
        this.fields = data.fields;
        this.fields.forEach((f)=>{f.score=0});
        this.instrux = data.instructions;
    }

    update (field,score) {
        //console.log("ScorecardModel.update("+field,score+")")
        var f = this.getField(field);
        if(!f)return;
        //console.log("f:"+f)
        isNaN(f.score)?f.score=score:f.score+=score;
        //console.log("f.score"+f.score);
    }

    passed (fieldId){
        console.log("ScorecardModel passed()");
        let p = true;
        let failCounter = 0
        if(!fieldId)
        {
            for(let i=0;i<this.fields.length;i++){
                let f=this.fields[i];
                if(!this.passed(f.id)){
                    ++failCounter;
                    if(failCounter>this.maxFails){
                        p = false;
                        break;
                    }
                }
                console.log("   "+fieldId+" passed:"+p);
            }
            console.log("All fields except "+failCounter+"passed!")
            return p;
        }
        else{
            var fi = this.getField(fieldId);
            p = (fi.score>=fi.min);
        }
       return p
    }

    getField(fieldId){
        return this.fields.find(f=>(fieldId===f.id));
    }

    getFieldByIndex(fieldIndex){
        return this.fields[fieldIndex];
    }

    getFields(){
        return this.fields;
    }

    get instructions(){
        console.log("get instructions")
        return this.instrux;
    }

    reset(){
        this.fields.forEach((f)=>(f.score=0));
    }
}

export default ScorecardModel;

